import axiosInstance from '../utils/axios';
import { getRole } from '../utils/role';

const getDeviceBasePath = () => {
  const role = getRole();
  if (role === 'SUPPORT') return '/super-admin';
  if ((role === 'PARTNER' || role === 'TEAM_MEMBER')) return '/admin';
  return null;
};

export const deviceApi = {
  getDeviceDetail: async (deviceId) => {
    const base = getDeviceBasePath();
    if (!base) throw new Error('Device details are not available for this role.');
    const { data } = await axiosInstance.get(`${base}/device-assignments/${encodeURIComponent(deviceId)}`);
    return data;
  },

  getDeviceHistory: async (deviceId) => {
    const role = getRole();
    if (role !== 'SUPPORT') return [];
    const { data } = await axiosInstance.get(
      `/super-admin/device-assignments/${encodeURIComponent(deviceId)}/history`
    );
    return data?.history || [];
  },

  /** Device assignment: GET /super-admin/hardware/dropdown */
  getHardwareDropdown: async (name = 'device') => {
    const { data } = await axiosInstance.get('/super-admin/hardware/dropdown', { params: { name } });
    return data?.data || [];
  },

  getHardwareDiff: async (targetId, baseId) => {
    const { data } = await axiosInstance.get(`/super-admin/hardware/${targetId}/diff`, {
      params: { base_id: baseId },
    });
    return data?.data || [];
  },

  /** Catalog listing only — do NOT use for device assignment dropdowns */
  getAllSoftware: async (type) => {
    const params = type ? { type } : undefined;
    const { data } = await axiosInstance.get('/super-admin/software', { params });
    return Array.isArray(data) ? data : [];
  },

  /** Device assignment: GET /super-admin/software/compatible/:hardware_id */
  getCompatibleSoftware: async (hardwareId, type) => {
    if (!hardwareId) return [];
    const params = type ? { type } : undefined;
    const { data } = await axiosInstance.get(
      `/super-admin/software/compatible/${hardwareId}`,
      { params }
    );
    return Array.isArray(data) ? data : [];
  },

  createSoftware: async (payload) => {
    const { data } = await axiosInstance.post('/super-admin/software', payload);
    return data?.software || data;
  },

  updateDeviceAssignment: async (deviceId, payload) => {
    const base = getDeviceBasePath();
    if (!base) throw new Error('Device update is not available for this role.');
    const { data } = await axiosInstance.put(
      `${base}/device-assignments/${encodeURIComponent(deviceId)}`,
      { data: payload }
    );
    return data;
  },
};
